import { Component, Input } from '@angular/core';
import { IFormGroup } from '@shared-libs/interfaces';
import { IAddress } from '@shared-models/address.model';

@Component({
	selector: 'form-full-address',
	templateUrl: 'form-full-address.component.html',
	styleUrls: ['./form-full-address.component.scss'],
})
export class FormFullAddressComponent {
	@Input() public formGroup: IFormGroup<IAddress>;
	@Input() public blockZipcode: boolean = false;

	public onAddressSelected(address: IAddress): void {
		this.setAddress(address);
	}

	private setAddress(address: IAddress): void {
		this.formGroup.patchValue(address);
	}
}
